import { useCallback } from "react";
import {
  ColumnsWithGroupData,
  getColumnsWithGroup,
} from "../../../api/Windows";
import { useWorkOrderStore } from "../../../store/wo-order";

export default function useGetIssueDetailsColumns() {
  const setIssueColumns = useWorkOrderStore((state) => state.setIssueColumns);

  const getIssueDetailsColumns = useCallback(async () => {
    const data: ColumnsWithGroupData = {
      WindowName: "mob_inventory_issue_details",
      IncludeValidValues: "true",
    };
    const response = await getColumnsWithGroup(data);
    setIssueColumns(response.data);
    return response;
  }, [setIssueColumns]);

  return { getIssueDetailsColumns };
}
